import React from 'react';
import getContent from '../../../lib/dictionaryFetcher';
import Col from 'kepler/lib/components/Col';

const ProductBundleHeader = () => {
  return (
    <div className="covid-header">
      <Col className="covid-header-left">
        <h2 className="covid-header-left-title">
          {getContent('covidbundles', 'pageHeader', '')}
        </h2>
        <p className="covid-header-left-description">
          {getContent('covidbundles', 'pageSubheader', '')}
        </p>
      </Col>
      <Col className="covid-header-right">
        <img
          className="covid-header-right-img"
          src="https://www.paypalobjects.com/ppcp/images/covid/covidheroimg.svg"
        />
      </Col>
    </div>
  );
};

export default ProductBundleHeader;
